/**
 * Ofusca un número de teléfono dejando visibles los 2 primeros y los 2 últimos dígitos, y sustituyendo
 * los intermedios por X (por ejemplo, "666123456" → "66XXXXX56").
 *
 * Se conserva la longitud original para que el usuario pueda reconocer su teléfono sin exponerlo.
 * Si el teléfono viene vacío o es tan corto que no quedaría nada oculto (4 dígitos o menos), se devuelve
 * tal cual: ofuscarlo no aportaría privacidad y sí confusión.
 */
export function obfuscatePhone(phone?: string | null): string
{
    const trimmedPhone = (phone ?? "").trim();

    if(trimmedPhone.length <= 4)
    {
        return trimmedPhone;
    }

    return trimmedPhone.slice(0, 2) + "X".repeat(trimmedPhone.length - 4) + trimmedPhone.slice(-2);
}
